import {useQuery} from '@tanstack/react-query';
import {rqCreateSearchRequest} from '@app/reactQuery/apis/rqHttpsUtils';
import {
  RQ_GET_ACTIVITY_API,
} from '@app/reactQuery/apis/constants/rqActivityAPIConstants';

export const RQUseGetActivityData = (payload, options = {}) => {
  return useQuery({
    queryKey:['rq_get_activity_data', payload],
    queryFn: async ({queryKey, signal}) => {
      const {certificate, divisionId} = queryKey[1];
      return rqCreateSearchRequest(
        RQ_GET_ACTIVITY_API,
        null,
        certificate,
        {
          divisionId: divisionId,
        },
        signal,
      );
    },
    ...options,
  });
};
